/**
 * SearchDescriptionContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled search description container.
 */

const SearchDescriptionContainer = styled.div<React.CSSProperties>`
  height: ${360 * Screen.widthRatio}px;
  left: ${316 * Screen.widthRatio}px;
  padding: ${25 * Screen.widthRatio}px ${66 * Screen.widthRatio}px 0 0;
  position: fixed;
  pointer-events: none;
  top: ${-32 * Screen.widthRatio}px;
  width: ${1360 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(SearchDescriptionContainer);
